












































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Home extends Vue {
  private handleSelect(key: string) {
      if (this.$route.name !== key) {
        this.$router.push({ name: key });
      }
    }
  }
